export default "__VITE_ASSET__d98cece4__"